/** @jsx jsx */
import { Link } from "gatsby"
import {
  jsx,
  Box
} from 'theme-ui'
import Layout from "../components/layout"
import Image from "../components/image"
import DRMSSidhuImage from '../components/DrMSSidhuImage'
import DrPreetiSidhuImage from '../components/DrPreetiSidhuImage'
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Box sx={{ m: '0 auto', mb: 5 }}>
      <Image />
    </Box>
    <p>
      Preet Hospital is a premier institute in women’s healthcare providing excellent medical and surgical services of the women of all age groups.
      Established in 2007 by Dr Manjit Singh Sidhu and Dr Preeti Sidhu, Preet Hospital has emerged as the pioneer institute in women’s healthcare.
      Your search for the best center providing top end surgical and other services ends here.
    </p>
    <h2 sx={{ mt: 7 }}>Our Doctors</h2>
    <Box sx={{ maxWidth: `300px`, m: '0 auto', mb: 5 }}>
      <DRMSSidhuImage />
      <h4 sx={{ textAlign: 'center', mt: 4 }}>Dr Manjit Singh Sidhu</h4>
    </Box>
    <p>
      Dr Manjit Singh Sidhu is highly qualified and widely experienced doctor to treat all types of gynecological disease surgically or by medicines.
      He is a pioneer surgeon and was the first in Northern India in 1998 to perform NDVH (Non descent vaginal hysterectomy) and popularize it.
      He has been in the forefront at using all modern technology and latest techniques for the best possible treatment of women.
    </p>
    <Box sx={{ maxWidth: `300px`, m: '0 auto', mb: 5, mt: 7 }}>
      <DrPreetiSidhuImage />
      <h4 sx={{ textAlign: 'center', mt: 4 }}>Dr Preetinder Kaur Sidhu</h4>
    </Box>
    <p>
      Dr Preeti Sidhu (Dr Preetinder Kaur Sidhu) has been a well-known and highly respected figure in the care of women in Bathinda and surroundings for the
      last over two decades. Having done her Post graduation from AFMC, a top, premier institute in India, she has brought a new dimension in care of women
      with her compassion and dedication.
    </p>
    <h3 sx={{ mt: 4 }}>Our Services</h3>
    <Box>
      <h5>
        Advanced Laparoscopic Surgery
      </h5>
      <p>
        TLH, LAVH, Myomectomy, Tubal surgery, Ovarian surgery, Endometriosis, sacrocolpopexy, Cervical circlage, Infertility surgery etc.
      </p>
      <h5>
        Hysteroscopic Surgery
      </h5>
      <p>
        Evaluation, Tubal Cannulation, Myomectomy, Synechiae removal, Septum removal, IUCD removal etc.
      </p>
      <h5>
        Advanced Vaginal Surgery
      </h5>
      <p>NDVH, Salpingectomy, Oopherectomy, Colporhaphy, Sacro-colposuspension etc.</p>
      <h5>
        Abdominal Surgery
      </h5>
      <p>Hysterectomy, Myomectomy, Tuboplasty, Cancer Surgery etc.</p>
      <h5>
        Surgery for Gynae Cancer
      </h5>
      <p>Cervical, Uterine, Ovarian and Vaginal Cancer Surgery</p>
      <h5>
        Urogynaecology
      </h5>
      <p>Surgery for Urinary fistula, Stress incontinence, Pelvic dysfunction and Pelvic floor surgeries</p>
      <h5>
        Gynae Reconstructive and cosmetic surgery
      </h5>
      <p>Vaginoplasty, Colporhaphy, Hymenoplasty, III/IV Degree Perineal tear repair</p>
      <h5>
        Normal delivery
      </h5>
      <p>Vacuum/Forceps Delivery, Painless Delivery</p>
      <h5>
        Caesarean Delivery
      </h5>
      <h5>
        Adolescent Clinic
      </h5>
      <h5>
        Antenatal Clinic
      </h5>
      <h5>
        High Risk Pregnancy Unit
      </h5>
      <p>Eclampsia, APH, Diabetes, Thyroid, Twins, Electronic Foetal Monitoring</p>
      <h5>
        Ultrasound Clinic
      </h5>
      <p>2D, 3D, 4D Ultrasound and Colour Doppler</p>
      <h5>
        Genetic Clinic
      </h5>
      <p>Amniocentesis and Chorionic Villous Sampling for Karyotyping and Microarray examination</p>
      <h5>
        MTP Clinic
      </h5>
      <p>Registered MTP Clinic for up to 20 weeks of pregnancy</p>
      <h5>
        Colposcopy and Cancer Screening
      </h5>
      <h5>
        Menopause Clinic
      </h5>
    </Box>
    <Link to="/about-us/">About Us</Link>
  </Layout>
)

export default IndexPage
